export const INPUT_TYPE = {
  TEXT: "TEXT",
  SELECT: "SELECT",
  DATE_TIME: "DATE_TIME",
  RANGE: "RANGE",
};

export const INPUT_SUB_TYPE = {
    PASSWORD:"password",
    EMAIL:"email"
}